// import axios from 'axios';
import axiosInstance from './axiosInstance';
import axios from 'axios';
import { OK_STATUS_CODE } from './constants';
import { sortTypeMapper } from '../utils/sorting';
import fileUploadApi from './fileUploadInstance';
import { APP_MASTER_TYPES, APP_USER_TYPES } from '../appContants';
import { API_ENDPOINTS } from './apiEndpoints';
// Uncomment the following line if you're using API_BASE_URL
const API_BASE_URL =
  'https://jf8gh0609g.execute-api.us-east-1.amazonaws.com/dev';

const apiService = {
  // Users
  async getUserProfile() {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.userProfile);
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      return undefined;
    }
  },
  async updateUserProfile(data) {
    const response = await axiosInstance.put(API_ENDPOINTS.userProfile, data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async getAllUsers(associationtype = APP_USER_TYPES.clinicUser) {
    try {
      const response = await axiosInstance.get(
        // TODO: remove static limit
        // handle through input search (paginated list)
        '/clinic/user/staff?limit=100&page=1',
        {
          params: {
            associationtype,
          },
        }
      );
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching users:', error); // Log the specific error message
      return;
    }
  },
  async updateStaff(data) {
    const response = await axiosInstance.put('/clinic/user/staff', data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async userList(params, associationtype = APP_USER_TYPES.clinicUser) {
    try {
      const response = await axiosInstance.get('/clinic/user/staff', {
        params: {
          associationtype,
          limit: params.limit,
          page: params.page,
          clinicId: params.clinicId,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching users:', error); // Log the specific error message
      return false;
    }
  },
  async getInvitedUser(id) {
    const res = await axios.get(
      `${API_BASE_URL}/cms/user/radiologist/invitation/${id}`
    );
    return res;
  },
  async signUPUser(cognitoUser) {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/radiologist/auth/user-signup`,
        cognitoUser
      );
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      throw error;
    }
  },
  async confirmSignupClinic(cognitoUser) {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/radiologist/auth/signup-confirmation`,
        cognitoUser
      );
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      return false;
    }
  },
  async getAllRadiologist() {
    try {
      const response = await axiosInstance.get(
        // TODO: remove static limit
        // handle through input search (paginated list)
        '/radiologist/user/radiologist?limit=100&page=1'
      );
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist:', error); // Log the specific error message
      return;
    }
  },
  async assignCaseToRadioLogist(caseId, data) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.radiologistCasesBase}/${caseId}/assign`,
      data
    );
    return res;
  },
  async unAssignCaseToRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.radiologistCasesBase}/${caseId}/unassign`
    );
    return res;
  },
  async acceptCaseFromRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.radiologistCasesBase}/${caseId}/accept`
    );
    return res;
  },
  async rejectCaseFromRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.radiologistCasesBase}/${caseId}/reject`
    );
    return res;
  },
  async resolveCaseFromRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.radiologistCasesBase}/${caseId}/resolve`
    );
    return res;
  },
  async markAsSubmittedCaseFromRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.radiologistCasesBase}/${caseId}/review_submit`
    );
    return res;
  },
  // Auth
  async signUPClinic(cognitoUser) {
    try {
      const res = await axiosInstance.post('/clinic/auth/signup', cognitoUser);
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      return false;
    }
  },
  async callme() {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.callMe);
      return response; // Return only the data, not the entire response object
    } catch (error) {
      throw new Error('Error fetching user'); // Rethrow the error
    }
  },
  // Branches
  async branchList(params) {
    try {
      const response = await axiosInstance.get('/clinic/locations', {
        params: {
          limit: params.limit,
          page: params.page,
          clinicId: params.clinicId,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data;
    } catch (error) {
      return [];
    }
  },
  async createBranch(data, params) {
    const response = await axiosInstance.post(`/clinic/locations/`, data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async updateBranch(id, data, params) {
    const response = await axiosInstance.put(`/clinic/locations/${id}`, data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  // Cases
  async caseList(params) {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.radiologistCasesBase,
        {
          params: {
            limit: params.limit,
            page: params.page,
            search: params.search,
            sortBy: params.sortBy,
            sortOrder: sortTypeMapper(params.sortOrder),
            caseReviewStatus: params?.caseReviewStatus,
            hasRush:params.hasRush?params.hasRush:null,
          },
        }
      );
      return response?.data?.data;
    } catch (error) {
      return [];
    }
  },
  async getCase(id) {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.radiologistCasesBase}/${id}`
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getCaseReportTemplate(id) {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.radiologistCasesBase}/${id}/report-template`
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getCaseFile(id, objectKey, fileName) {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.radiologistCasesBase}/${id}/files`,
        {
          params: { objectKey, fileName },
        }
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getPresignedUrl(data) {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.radiologistCasesBase}/files`,
      data
    );
    return response?.data?.data;
  },
  async getPresignedForProfileUrl(data) {
    const response = await axiosInstance.post(
      `/radiologist/user/profile/photo`,
      data
    );
    return response?.data?.data;
  },
  async uploadWithPresignedUrl(url, data, onProgress) {
    return await fileUploadApi.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: ({ total, loaded }) => {
        onProgress?.({ percent: Math.round((loaded / total) * 100) });
      },
    });
  },
  async createCase(data, params) {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.radiologistCasesBase}`,
      data,
      {
        params,
      }
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async updateCase(id, data, params) {
    const response = await axiosInstance.put(
      `${API_ENDPOINTS.radiologistCasesBase}/${id}`,
      data,
      {
        params,
      }
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async deleteCase(id) {
    const response = await axiosInstance.delete(
      `${API_ENDPOINTS.radiologistCasesBase}/${id}`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  // Case Services
  async servicesList() {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.cmsMaster, {
        params: {
          masterType: APP_MASTER_TYPES.service,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  // Radiologist Invoice
  async getRadiologistInvoiceList(params) {
    try {
      const response = await axiosInstance.get(
        '/radiologist/radiologist-invoices',
        {
          params: {
            limit: params.limit,
            page: params.page,
            search: params.search,
            sortBy: params.sortBy,
            sortOrder: sortTypeMapper(params.sortOrder),
          },
        }
      );
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist invoice list:', error); // Log the specific error message
      return;
    }
  },
  async getRadiologistInvoice(id) {
    try {
      const response = await axiosInstance.get(
        `${'/radiologist/radiologist-invoices'}/${id}`
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  // Dashboard API requests
  async getDashboard() {
    try {
      const response = await axiosInstance.get('/radiologist/cases/dashboard');
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching dashboard list:', error); // Log the specific error message
      throw error;
    }
  },
  // Add more API functions as needed
};

export default apiService;
